import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Rooms API
export const getRooms = () => axios.get(`${API}/rooms`);
export const createRoom = (data) => axios.post(`${API}/rooms`, data);
export const updateRoom = (id, data) => axios.put(`${API}/rooms/${id}`, data);
export const deleteRoom = (id) => axios.delete(`${API}/rooms/${id}`);
export const updateOccupancy = (id, data) => axios.put(`${API}/rooms/${id}/occupancy`, data);

// Competitors API
export const getCompetitors = () => axios.get(`${API}/competitors`);
export const createCompetitor = (data) => axios.post(`${API}/competitors`, data);
export const updateCompetitor = (id, data) => axios.put(`${API}/competitors/${id}`, data);
export const deleteCompetitor = (id) => axios.delete(`${API}/competitors/${id}`);

// Pricing Rules API
export const getRules = () => axios.get(`${API}/rules`);
export const createRule = (data) => axios.post(`${API}/rules`, data);
export const updateRule = (id, data) => axios.put(`${API}/rules/${id}`, data);
export const deleteRule = (id) => axios.delete(`${API}/rules/${id}`);
export const toggleRule = (id) => axios.put(`${API}/rules/${id}/toggle`);

// Price History API
export const getPriceHistory = (roomTypeId) => {
  const params = roomTypeId ? { room_type_id: roomTypeId } : {};
  return axios.get(`${API}/price-history`, { params });
};

// Dashboard API
export const getDashboardMetrics = () => axios.get(`${API}/dashboard/metrics`);
export const getRevenueChart = () => axios.get(`${API}/dashboard/revenue-chart`);
export const getOccupancyChart = () => axios.get(`${API}/dashboard/occupancy-chart`);

// Revenue Engine API
export const recalculatePrices = () => axios.post(`${API}/revenue/recalculate`);

// AI Analysis API
export const getAIAnalysis = (analysisType, model = "claude") => axios.post(`${API}/ai/analyze`, { analysis_type: analysisType, model });
export const getPredictiveAnalysis = (daysAhead = 14) => axios.post(`${API}/ai/predictive`, { days_ahead: daysAhead });
export const getOptimizedPrices = () => axios.post(`${API}/ai/optimize-prices`);

// Seed Data API
export const seedData = () => axios.post(`${API}/seed`);

export default {
  getRooms,
  createRoom,
  updateRoom,
  deleteRoom,
  updateOccupancy,
  getCompetitors,
  createCompetitor,
  updateCompetitor,
  deleteCompetitor,
  getRules,
  createRule,
  updateRule,
  deleteRule,
  toggleRule,
  getPriceHistory,
  getDashboardMetrics,
  getRevenueChart,
  getOccupancyChart,
  recalculatePrices,
  getAIAnalysis,
  seedData,
};
